/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Trust_Song_TitleInputs */

const en_directory_ai_tools_trust_song_title = /** @type {(inputs: Directory_Ai_Tools_Trust_Song_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Original song, safe to post`)
};

const zh_directory_ai_tools_trust_song_title = /** @type {(inputs: Directory_Ai_Tools_Trust_Song_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原创歌曲，放心发布`)
};

/**
* | output |
* | --- |
* | "Original song, safe to post" |
*
* @param {Directory_Ai_Tools_Trust_Song_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_trust_song_title = /** @type {((inputs?: Directory_Ai_Tools_Trust_Song_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Trust_Song_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_trust_song_title(inputs)
	return zh_directory_ai_tools_trust_song_title(inputs)
});
export { directory_ai_tools_trust_song_title as "directory.ai_tools.trust.song_title" }